import React from 'react';

import classes from './Point.module.scss';

const Point = () => {
  return <div className={classes.point}>·</div>;
};

export { Point };
